import { Segmented } from "antd";
import { useState } from "react";
import { UserInfo, UserRoles } from "./data";

export const UserDetails = (props) => {
  const { dataId } = props;
  const [activeTab, setActiveTab] = useState("info");

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h2 fw-bold text-custom">User Details</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card shadow border-red p-3">
              <Segmented
                size="middle"
                className="pt-2 ps-2 pe-2 pb-0"
                block
                onChange={(e) => setActiveTab(e)}
                options={[
                  {
                    label: "User Info",
                    value: "info",
                    icon: <i className="bi bi-person fs-5" />,
                  },
                  {
                    label: "User Roles",
                    value: "roles",
                    icon: <i className="bi bi-list-nested fs-5" />,
                  },
                  {
                    label: "User Logs",
                    value: "logs",
                    icon: <i className="bi bi-activity fs-5" />,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row mt-0">
          <div className="col-12">
            {activeTab === "info" && <UserInfo dataId={dataId} />}
          </div>
          <div className="col-12">
            {activeTab === "roles" && <UserRoles userId={dataId} />}
          </div>
        </div>
      </div>
    </>
  );
};
